import React from "react";
import { useNavigate } from "react-router-dom";
import { routeCodes } from "../../config/routes";
import { premiumRequired } from "../../utilities";
import { printableCategoryNavNames, printableCategories } from "../../config/categories";
import FlareShimmer from "../global/FlareShimmer";
import Shimmer from "../../../assets/img/shimmer2.png";
import { getLangCode } from "../../config";

export default function CategoryNav() {
  const navigate = useNavigate();

  return printableCategoryNavNames.map((navName) => {
    const printableObject = printableCategories.find(
      ({ shortname, localeShortname }) => localeShortname === navName || shortname === navName,
    );

    if (printableObject) {
      return (
        <button
          type="button"
          key={navName}
          className={`button-flat-color round dimensional ${printableObject.shortname} ${getLangCode()}`}
          onClick={() => {
            navigate(`${routeCodes.CATEGORYPRINTABLES}${printableObject.localeShortname || printableObject.shortname}`);
          }}
        >
          {printableObject.name}
          <div className="pnc-button-premium-container">
            {premiumRequired([printableObject.shortname]) && (
              <div className="pnc-button-premium">
                <FlareShimmer filePath={Shimmer} />
              </div>
            )}
          </div>
        </button>
      );
    }

    return null;
  });
}
